const euroFmt = new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" });
const timeFmt = new Intl.DateTimeFormat("es-ES", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Madrid" });
const dayFmt = new Intl.DateTimeFormat("es-ES", { weekday: "short", day: "numeric", month: "short", timeZone: "Europe/Madrid" });

export const euros = (cents: number) => euroFmt.format(cents / 100);
export const time = (iso: string) => timeFmt.format(new Date(iso));
export const day = (iso: string) => dayFmt.format(new Date(iso));
export const usd = (micro: number) => (micro / 1e6).toLocaleString("es-ES", { style: "currency", currency: "USD", minimumFractionDigits: micro && micro < 10_000 ? 3 : 2 });

/** «ahora», «hace 5 min», «18:30», «ayer, 18:30» or «mar, 4 nov, 18:30». */
export function relative(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const s = Math.round((now.getTime() - d.getTime()) / 1000);
  if (s < 0) { const m = Math.ceil(-s / 60); return m < 60 ? `en ${m} min` : `${day(iso)}, ${time(iso)}`; }
  if (s < 60) return "ahora";
  if (s < 3600) return `hace ${Math.floor(s / 60)} min`;
  if (dayFmt.format(d) === dayFmt.format(now)) return time(iso);
  const yesterday = new Date(now); yesterday.setDate(yesterday.getDate() - 1);
  if (dayFmt.format(d) === dayFmt.format(yesterday)) return `ayer, ${time(iso)}`;
  return `${day(iso)}, ${time(iso)}`;
}

/** «1.500,50», «1500.5» or «12 €» → cents; null if it is not an amount. */
export function toCents(text: string): number | null {
  const t = text.trim().replace(/\s|€/g, "");
  if (!t) return null;
  const thousands = /^\d{1,3}(\.\d{3})+$/.test(t);
  const normal = t.includes(",") || thousands ? t.replace(/\./g, "").replace(",", ".") : t;
  if (!/^\d+(\.\d{1,2})?$/.test(normal)) return null;
  return Math.round(Number(normal) * 100);
}

export const plainAmount = (cents: number) => (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
